import React, { memo, forwardRef } from "react";
const SvgEpsilon = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M16.352 23.016c-1.856 0-3.216-.352-4.08-1.056-.848-.72-1.272-1.616-1.272-2.688 0-.64.12-1.16.36-1.56.256-.416.584-.744.984-.984a5.546 5.546 0 011.368-.6v-.12c-.688-.224-1.24-.568-1.656-1.032-.416-.48-.624-1.104-.624-1.872 0-.736.184-1.352.552-1.848.384-.512.928-.904 1.632-1.176.72-.272 1.576-.408 2.568-.408.896 0 1.704.096 2.424.288.395.094.75.2 1.066.317.433.161.61.652.446 1.083-.203.527-.826.748-1.354.549a7.528 7.528 0 00-.686-.221 6.465 6.465 0 00-1.896-.264c-.96 0-1.648.168-2.064.504-.4.32-.6.76-.6 1.32 0 .736.288 1.256.864 1.56.592.288 1.272.432 2.04.432h.84a.816.816 0 110 1.632h-.84c-.704 0-1.296.088-1.776.264-.48.176-.848.432-1.104.768-.24.336-.36.752-.36 1.248 0 .688.272 1.208.816 1.56.56.336 1.344.504 2.352.504.832 0 1.552-.064 2.16-.192.138-.028.273-.06.405-.095.603-.158 1.275.261 1.275.884 0 .312-.172.602-.462.714a5.917 5.917 0 01-1.266.321c-.656.112-1.36.168-2.112.168z"
      />
    </svg>
  );
});
SvgEpsilon.displayName = "SvgEpsilon";
const MemoForwardRef = memo(SvgEpsilon);
export default MemoForwardRef;
